<template>
  <div class="edit">
    <div class="title">修改密码</div>
    <div class="cont">
      <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules" v-bind="layout">
<!--        <a-form-model-item  required label="邮箱" prop="email" v-show="false">-->
<!--          <a-input size="large" v-model="ruleForm.email" disabled type="email" autocomplete="off" />-->
<!--        </a-form-model-item>-->
        <a-form-model-item  required label="旧密码" prop="oldpass">
          <a-input-password size="large" v-model="ruleForm.oldpass" type="password" autocomplete="off" />
        </a-form-model-item>
        <a-form-model-item  required label="新密码" prop="newpass">
          <a-input-password size="large" v-model="ruleForm.newpass" type="password" autocomplete="off" />
        </a-form-model-item>
        <a-form-model-item  required label="确认密码" prop="checkPass">
          <a-input-password size="large" v-model="ruleForm.checkPass" type="password" autocomplete="off" />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 18, offset: 8 }">
          <a-button type="primary" @click="submitForm('ruleForm')">确认修改</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>

  </div>
</template>

<script>
import request from '../../utils/requestUrl.js'
import axios from 'axios'
import md5 from '../../utils/md5.js'
import { CLIENT_SECRET } from '../../utils/authClient.js'
import { JSEncrypt } from 'jsencrypt'
const CryptoJS = require('crypto-js')

export default {
  name: 'editPassword',
  data () {
    let checkPending
    const checkAge = (rule, value, callback) => {
      clearTimeout(checkPending)
      if (!value) {
        return callback(new Error('Please input the age'))
      }
      checkPending = setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error('Please input digits'))
        } else {
          if (value < 18) {
            callback(new Error('Age must be greater than 18'))
          } else {
            callback()
          }
        }
      }, 1000)
    }
    const validateOldPass = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入旧密码！'))
        return
      }
      callback()
    }
    const validatePass = (rule, value, callback) => {
      const str = value
      if (!str) {
        callback(new Error('请输入密码！'))
        return
      }
      if (str.length < 6) {
        callback(new Error('密码长度不少于6位！！'))
        return
      }
      if (str.length > 16) {
        callback(new Error('请您输入密码小于16位！'))
        return
      }
      const hasLetter = /[A-Za-z]/.test(str)
      const hasDigit = /[0-9]/.test(str)
      if (!hasLetter || !hasDigit) {
        callback(new Error('密码必须有数字+字母'))
        return
      }
      if (this.ruleForm.checkPass !== '') {
        this.$refs.ruleForm.validateField('checkPass')
      }
      callback()
    }
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认密码！'))
      } else if (value !== this.ruleForm.newpass) {
        callback(new Error('两次输入不一致!'))
      } else {
        callback()
      }
    }
    return {
      request,
      ruleForm: {
        email: this.$store.state.userInfo.email,
        newpass: '',
        oldpass: '',
        checkPass: ''
      },
      rules: {
        newpass: [{ validator: validatePass, trigger: 'change' }],
        oldpass: [{ validator: validateOldPass, trigger: 'change' }],
        checkPass: [{ validator: validatePass2, trigger: 'change' }]
      },
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 14 }
      },
      encryptionKey: ''
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.ruleForm)
          const _this = this
          const param = {
            id: this.$getUserInfo().id,
            newPassword: this.ruleForm.newpass,
            confirmPassword: this.ruleForm.checkPass
          }
          // console.log(param)
          const sign = md5.paramMd5(param, 'client_secret', CLIENT_SECRET)
          param.sign = sign
          // 生成随机密钥
          const random = CryptoJS.lib.WordArray.random(24)
          const keyBase64 = CryptoJS.enc.Base64.stringify(random)
          // 加密参数encryptionKey--使用RSA加密算法
          const encrypt = new JSEncrypt()
          encrypt.setPublicKey(_this.encryptionKey)
          const key = encrypt.encrypt(keyBase64)
          // 加密参数encryptionData--对称加密AES
          const data = _this.aesEncrypt_EBC(JSON.stringify(param), keyBase64)
          const encrypParam = {}
          encrypParam.encryptionKey = key
          encrypParam.encryptionData = data
          encrypParam.access_token = localStorage.getItem('access_token')

          axios({
            url: this.$loginServer + request.updatePasswordByUserId,
            method: 'POST',
            data: encrypParam
          }).then((res) => {
            console.log('res', res)
            if (res && res.data.resultCode === '0' && res.data.success === true) {
              const jsonString = _this.aesDecrypt_EBC(res.data.resultData.encryptionData, keyBase64)
              const decryptedData = JSON.parse(jsonString)
              console.log('decryptedData', decryptedData)
              if (decryptedData) {
                this.$message.success('更新密码成功')
                // this.$router.push({name: 'MyInfo'})
                this.ruleForm.newpass = ''
                this.ruleForm.checkPass = ''
                this.ruleForm.oldpass = ''
              } else {
                this.$message.warning('更新密码失败')
              }
            } else {
              this.$message.warning('更新密码失败')
            }
          })

          // const param = {
          //   access_token: this.$store.state.access_token,
          //   userId: this.$store.state.userId,
          //   oraPassword: this.ruleForm.oldpass,
          //   newPassword: this.ruleForm.newpass,
          //   confirmPassword: this.ruleForm.checkPass
          // }
          // this.$http.post(request.updatePasswordByUserId, param).then(res => {
          //   console.log(res)
          //   if (res) {
          //     this.$message.success('更新密码成功')
          //     this.$router.push({ name: 'MyInfo' })
          //   } else {
          //     this.$message.warning('更新密码失败')
          //   }
          // })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    CheckPassWord (password) {
      const str = password
      if (!str || str.length < 6) {
        this.$message.warning('密码长度不少于6位！')
        return false
      }
      if (str.length > 16) {
        this.$message.warning('密码长度不大于16位！')
        return false
      }
      const hasLetter = /[A-Za-z]/.test(str)
      const hasDigit = /[0-9]/.test(str)
      if (!hasLetter || !hasDigit) {
        this.$message.warning('密码必须有数字+字母！')
        return false
      }
      return true
    },
    getPublicSecret () {
      // 获取加密公钥
      const _this = this
      axios({
        url: this.$loginServer + 'auth/res/getPublicSecret'
      }).then((res) => {
        console.log(res)
        if (res && res.data && res.data.resultCode === '0') {
          _this.encryptionKey = res.data.resultData
          // console.log(_this.encryptionKey)
        }
      })
    },
    aesEncrypt_EBC: function (word, keySec) {
      // aes加密
      const aeskey = CryptoJS.enc.Utf8.parse(keySec)
      const srcs = CryptoJS.enc.Utf8.parse(word)
      const encrypted = CryptoJS.AES.encrypt(srcs, aeskey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
      return encrypted.ciphertext.toString()
    },
    aesDecrypt_EBC: function (word, keySec) {
      // aes解密
      const aeskey = CryptoJS.enc.Utf8.parse(keySec)
      const encryptedHexStr = CryptoJS.enc.Hex.parse(word)
      const srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
      const decrypt = CryptoJS.AES.decrypt(srcs, aeskey, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
      const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
      return decryptedStr.toString()
    }
  },
  mounted () {
    this.getPublicSecret()
  }

}
</script>

<style lang="less" scoped>
.edit{
  height: 100%;

  .title{
    color: #333;
    font-size: 18px;
    border-bottom: 1px solid #f2f2f2;
    text-indent: 30px;
    height: 50px;
    line-height: 50px;
    font-weight: 600;
  }
  .cont{
    width: 460px;
    margin: 50px auto 0 80px;
  }
}

/deep/ .ant-form label{
  font-size: 16px;
  margin-right: 10px;
}
/deep/ .ant-btn {
  font-size: 16px;
}

/deep/ .ant-col-14 {

  margin-left: 20px;
}
</style>
